
// Constants

import { INPUT_TYPES } from '../../inputs/inputTypes';
import { VALIDATION_TYPES } from '../../inputs/validationTypes';
import { VALIDATION_ERROR_MESSAGES } from '../../inputs/validationErrorMessages';

const DETAILS_INPUTS = {
    alienNumber: {
        name: 'alienNumber',
        type: INPUT_TYPES.MASKED_INPUT,
        text: 'ssap.input.label.alien_number',
        isInputRequired: true,
        placeholder: 'ssap.input.placeholder.alien_number',
        validationType: VALIDATION_TYPES.ALIEN_NUMBER
    },
    cardNumber: {
        name: 'cardNumber',
        type: INPUT_TYPES.REGULAR_INPUT,
        text: 'ssap.input.label.card_number',
        isInputRequired: true,
        placeholder: 'ssap.input.placeholder.card_number',
        validationType: VALIDATION_TYPES.I_551
    },
    documentExpirationDate: {
        name: 'documentExpirationDate',
        type: INPUT_TYPES.DATE_PICKER,
        text: 'ssap.input.label.passport_expiration_date',
        isInputRequired: false,
        placeholder: 'ssap.input.placeholder.passport_expiration_date',
        specificValidation: {
            validationType: VALIDATION_TYPES.DATE_OR_NULL
        },
        validationType: VALIDATION_TYPES.DATE
    },
    foreignPassportOrDocumentNumber: {
        name: 'foreignPassportOrDocumentNumber',
        type: INPUT_TYPES.MASKED_INPUT,
        text: 'ssap.input.label.passport_number',
        isInputRequired: true,
        placeholder: 'ssap.input.placeholder.passport_number',
        validationType: VALIDATION_TYPES.PASSPORT,
    },
    foreignPassportCountryOfIssuance: {
        name: 'foreignPassportCountryOfIssuance',
        type: INPUT_TYPES.DROPDOWN,
        text: 'ssap.input.label.country_of_issuance',
        isInputRequired: true,
        options: [],
        validationType: VALIDATION_TYPES.CHOSEN,
        validationErrorMessage: VALIDATION_ERROR_MESSAGES.COUNTRY_OF_ISSUANCE
    },
    visaNumber: {
        name: 'visaNumber',
        type: INPUT_TYPES.MASKED_INPUT,
        text: 'ssap.input.label.visa_number',
        isInputRequired: false,
        placeholder: 'ssap.input.placeholder.visa_number',
        validationType: VALIDATION_TYPES.VISA
    },
    i94Number: {
        name: 'i94Number',
        type: INPUT_TYPES.MASKED_INPUT,
        text: 'ssap.input.label.i_94_number',
        isInputRequired: true,
        placeholder: 'ssap.input.placeholder.i_94_number',
        validationType: VALIDATION_TYPES.I_94
    },
    sevisId: {
        name: 'sevisId',
        type: INPUT_TYPES.MASKED_INPUT,
        text: 'ssap.input.label.sevis_id_number',
        isInputRequired: false,
        placeholder: 'ssap.input.placeholder.sevis_id_number',
        validationType: VALIDATION_TYPES.SEVIS_ID
    },
    documentDescription: {
        name: 'documentDescription',
        type: INPUT_TYPES.REGULAR_INPUT,
        text: 'ssap.input.label.document_description',
        isInputRequired: true,
        placeholder: 'ssap.input.placeholder.document_description',
        validationType: VALIDATION_TYPES.DOCUMENT_DESCRIPTION
    }
};

export const ELIGIBILITY_DOCUMENTS = [
    {
        name: 'I551Indicator',
        text: 'ssap.input.label.i_551_number',
        details: [
            { ...DETAILS_INPUTS.alienNumber },
            { ...DETAILS_INPUTS.cardNumber },
            {
                ...DETAILS_INPUTS.documentExpirationDate,
                text: 'ssap.input.label.expiration_date'
            }
        ]
    },
    {
        name: 'TemporaryI551StampIndicator',
        text: 'ssap.input.label.i_551_stamp_number',
        details: [
            { ...DETAILS_INPUTS.alienNumber },
            { ...DETAILS_INPUTS.foreignPassportOrDocumentNumber },
            { ...DETAILS_INPUTS.foreignPassportCountryOfIssuance },
            { ...DETAILS_INPUTS.documentExpirationDate }
        ]
    },
    {
        name: 'MachineReadableVisaIndicator',
        text: 'ssap.input.label.i_551_readable_number',
        details: [
            { ...DETAILS_INPUTS.alienNumber },
            { ...DETAILS_INPUTS.foreignPassportOrDocumentNumber },
            { ...DETAILS_INPUTS.foreignPassportCountryOfIssuance },
            { ...DETAILS_INPUTS.documentExpirationDate },
            { ...DETAILS_INPUTS.visaNumber }
        ]
    },
    {
        name: 'I766Indicator',
        text: 'ssap.input.label.i_766_number',
        details: [
            {
                ...DETAILS_INPUTS.alienNumber,
                validationType: VALIDATION_TYPES.ALIEN_NUMBER
            },
            { ...DETAILS_INPUTS.cardNumber },
            {
                ...DETAILS_INPUTS.documentExpirationDate,
                isInputRequired: true,
                text: 'ssap.input.label.expiration_date'
            }
        ]
    },
    {
        name: 'I94Indicator',
        text: 'ssap.input.label.arrival_departure_record',
        details: [
            { ...DETAILS_INPUTS.i94Number },
            { ...DETAILS_INPUTS.sevisId },
            { ...DETAILS_INPUTS.documentExpirationDate }
        ]
    },
    {
        name: 'I94InPassportIndicator',
        text: 'ssap.input.label.arrival_departure_passport_record',
        details: [
            { ...DETAILS_INPUTS.i94Number },
            { ...DETAILS_INPUTS.foreignPassportOrDocumentNumber },
            { ...DETAILS_INPUTS.foreignPassportCountryOfIssuance },
            {
                ...DETAILS_INPUTS.documentExpirationDate,
                isInputRequired: true
            },
            { ...DETAILS_INPUTS.visaNumber },
            { ...DETAILS_INPUTS.sevisId }
        ]
    },
    {
        name: 'UnexpiredForeignPassportIndicator',
        text: 'ssap.input.label.foreign_passport',
        details: [
            {
                ...DETAILS_INPUTS.i94Number,
                isInputRequired: false
            },
            { ...DETAILS_INPUTS.foreignPassportOrDocumentNumber },
            { ...DETAILS_INPUTS.foreignPassportCountryOfIssuance },
            {
                ...DETAILS_INPUTS.documentExpirationDate,
                isInputRequired: true
            },
            { ...DETAILS_INPUTS.sevisId }
        ]
    },
    {
        name: 'I327Indicator',
        text: 'ssap.input.label.i_327_number',
        details: [
            { ...DETAILS_INPUTS.alienNumber },
            {
                ...DETAILS_INPUTS.documentExpirationDate,
                text: 'ssap.input.label.expiration_date'
            }
        ]
    },
    {
        name:'I571Indicator',
        text: 'ssap.input.label.i_571_number',
        details: [
            { ...DETAILS_INPUTS.alienNumber },
            {
                ...DETAILS_INPUTS.documentExpirationDate,
                text: 'ssap.input.label.expiration_date'
            }
        ]
    },
    {
        name: 'I20Indicator',
        text: 'ssap.input.label.i_20_number',
        details: [
            {
                ...DETAILS_INPUTS.sevisId,
                isInputRequired: true
            },
            {
                ...DETAILS_INPUTS.i94Number,
                isInputRequired: false
            },
            {
                ...DETAILS_INPUTS.foreignPassportOrDocumentNumber,
                isInputRequired: false
            },
            { ...DETAILS_INPUTS.foreignPassportCountryOfIssuance },
            { ...DETAILS_INPUTS.documentExpirationDate }
        ]
    },
    {
        name: 'DS2019Indicator',
        text: 'ssap.input.label.ds_2019_number',
        details: [
            {
                ...DETAILS_INPUTS.sevisId,
                isInputRequired: true
            },
            {
                ...DETAILS_INPUTS.i94Number,
                isInputRequired: false
            },
            {
                ...DETAILS_INPUTS.foreignPassportOrDocumentNumber,
                isInputRequired: false
            },
            { ...DETAILS_INPUTS.documentExpirationDate }
        ]
    },
    {
        name: 'I797Indicator',
        text: 'ssap.input.label.i_797_number',
        details: [
            {
                ...DETAILS_INPUTS.alienNumber,
                isInputRequired: false
            },
            {
                ...DETAILS_INPUTS.i94Number,
                isInputRequired: false
            }
        ]
    },
    {
        name: 'OtherDocumentTypeIndicator',
        text: 'ssap.input.label.other_status',
        details: [
            {
                ...DETAILS_INPUTS.alienNumber,
                isInputRequired: false
            },
            {
                ...DETAILS_INPUTS.foreignPassportOrDocumentNumber,
                isInputRequired: false
            },
            { ...DETAILS_INPUTS.sevisId },
            {
                ...DETAILS_INPUTS.documentExpirationDate ,
                isInputRequired: false
            },
            { ...DETAILS_INPUTS.documentDescription }
        ]
    },
    {
        name: 'noneOfThese',
        text: 'ssap.input.label.none_of_these',
        details: []
    }
];